// extracted by mini-css-extract-plugin
module.exports = {"summary":"bckbxKVmbv1sSRaPdVHm8","row":"_3SPKTxnsoXkbL5sZEFUFMx","rowLand":"_2o4waX_nGaqSIO56B3aJqU"};